module.exports = __webpack_public_path__ + "img/rulesCloud1.2fb1e8df.png";